import { RiCheckLine, RiEdit2Line } from "@remixicon/react";
import type { EEvaluatorStatus } from "~/hooks/use-evaluator";
import { cn } from "~/lib/utils";
import Loader from "./loader";

interface IProps {
  status: EEvaluatorStatus;
}

const EvaluatorStatus = ({ status }: IProps) => {
  if (status === "NONE") return null;

  const color: Record<Exclude<EEvaluatorStatus, "NONE">, string> = {
    PENDING: "text-gray-500 border-gray-500 bg-gray-500/25",
    FAIL: "text-yellow-500 border-yellow-500 bg-yellow-500/15",
    PASS: "text-green-500 border-green-500 bg-green-500/25",
  };

  const text: Record<Exclude<EEvaluatorStatus, "NONE">, string> = {
    PENDING: "Aan het evalueren...",
    FAIL: "Aanpassing is aanbevolen",
    PASS: "Geen aanpassing meer nodig",
  };

  const icon: Record<Exclude<EEvaluatorStatus, "NONE">, React.ReactNode> = {
    PENDING: <Loader size={20} className="animate-spin" />,
    FAIL: <RiEdit2Line size={20} />,
    PASS: <RiCheckLine size={20} />,
  };

  return (
    <div
      className={cn(
        "p-2 text-sm w-full border rounded-md gap-1.5 flex items-center",
        color[status]
      )}
    >
      {icon[status]}
      {text[status]}
    </div>
  );
};

export default EvaluatorStatus;
